module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shows-wrapper"
  }, [_c('div', {
    staticClass: "grid-100 grid-parent"
  }), _vm._v(" "), _c('h1', {
    staticClass: "main-title individual grid-container"
  }, [_vm._v("Shows")]), _vm._v(" "), _c('div', {
    staticClass: "grid-100 grid-parent layer2"
  }, [_c('div', {
    staticClass: " grid-container"
  }, [_c('div', {
    staticClass: "grid-45 grid-parent"
  }, _vm._l((_vm.embeddedVideos), function(video) {
    return (video.video_link) ? _c('div', {
      key: video.video_link,
      staticClass: "video-item grid-100 grid-parent"
    }, [_c('div', {
      staticClass: "video-header shows grid-100 grid-parent"
    }, [_c('div', {
      staticClass: "video"
    }, [_c('iframe', {
      attrs: {
        "width": "560",
        "height": "315",
        "src": 'https://www.youtube.com/embed/' + video.video_link,
        "frameborder": "0",
        "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
        "allowfullscreen": ""
      }
    })])])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tour-dates grid-50 push-5"
  }, [_c('Loader', {
    attrs: {
      "active": !_vm.showsLoaded
    }
  }), _vm._v(" "), _vm._l((_vm.tours), function(tour, indexTour) {
    return (tour.shows && tour.shows.length) ? _c('div', {
      key: indexTour,
      staticClass: "tour-group-wrapper",
      class: {
        open: tour.open, close: !tour.open
      }
    }, [_c('h4', {
      staticClass: "tour-name",
      class: {
        open: tour.open, close: !tour.open
      },
      domProps: {
        "innerHTML": _vm._s(tour.title.rendered)
      },
      on: {
        "click": function($event) {
          return _vm.openTour(tour, indexTour)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tour-wrapper",
      class: {
        open: tour.open, close: !tour.open
      }
    }, _vm._l((tour.shows), function(showMonth, index) {
      return (showMonth) ? _c('div', {
        key: index,
        staticClass: "shows-month-wrapper"
      }, [_c('h4', {
        staticClass: "month"
      }, [_vm._v(_vm._s(showMonth[0].date_display_date))]), _vm._v(" "), _c('ul', {
        staticClass: "tour-list"
      }, _vm._l((showMonth), function(show, index) {
        return _c('li', {
          key: index,
          staticClass: "tour-event grid-100 grid-parent"
        }, [_c('span', {
          staticClass: "date"
        }, [_vm._v(_vm._s(_vm.getDateInFormat(show.show_date)))]), _vm._v(" "), _c('span', {
          staticClass: "location"
        }, [_vm._v(_vm._s(show.place) + " ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isDatePast(show.show_date)),
            expression: "!isDatePast(show.show_date)"
          }]
        }, [_c('a', {
          staticClass: "buy layer1",
          attrs: {
            "href": show.tickets_link,
            "target": "_blank"
          }
        }, [_c('span', {
          staticClass: "tour-cta"
        }, [_vm._v("Buy Tickets ")])]), _vm._v(" "), _c('a', {
          staticClass: "buy layer1",
          attrs: {
            "href": show.tickets_link,
            "target": "_blank"
          }
        }, [_c('span', {
          staticClass: "tour-cta-mobile"
        }, [_vm._v("Buy ")])])])])
      }), 0)]) : _vm._e()
    }), 0)]) : _vm._e()
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.showsLoaded && _vm.tours.length === 0)),
      expression: "(showsLoaded && tours.length === 0)"
    }],
    staticClass: "no-shows"
  }, [_vm._v("Sorry, there are no dates available")])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e28d162","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shows.vue
// module id = 283
// module chunks = 0